module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.activeClass
  }, [_c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('button', {
    staticClass: "sidebar-toggler",
    on: {
      "click": _vm.showSideBar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-nav",
    attrs: {
      "data-mcs-theme": "light"
    }
  }, [_c('ul', {
    staticClass: "nav-main",
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.isDashboard
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showDashboard($event)
      }
    }
  }, [_vm._m(0), _vm._v(" " + _vm._s(_vm.labels.DASHBOARD_TEXT) + "\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "collapse-icon collapse",
    attrs: {
      "data-toggle": "collapse"
    },
    on: {
      "click": function($event) {
        _vm.collapseElement($event, 'navMainProducts')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v("\n            " + _vm._s(_vm.actionText) + "\n          ")]), _vm._v(" "), _c('ul', {
    ref: "navMainProducts",
    staticClass: "collapse in",
    attrs: {
      "id": "navMainProducts"
    }
  }, [(!_vm.isCurrentUserAdmin) ? _c('li', [_c('a', {
    class: {
      active: _vm.isChangePassword
    },
    on: {
      "click": function($event) {
        _vm.showChangePassword($event, _vm.actionText, _vm.changePasswordText)
      }
    }
  }, [_vm._v(_vm._s(_vm.changePasswordText))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin) ? _c('li', [_c('a', {
    class: {
      active: _vm.isUsersList
    },
    on: {
      "click": function($event) {
        _vm.showUsersList($event, _vm.actionText, _vm.usersListText)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.usersListText))])]) : _vm._e()])]), _vm._v(" "), _c('li')])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "page-header page-header-sm"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "mmk-icon mmk-icon-24 mmk-icon-book-image",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.openedSubPoint))])])])]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nav-icon btn btn-size-32"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-home",
    attrs: {
      "aria-hidden": "false"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nav-icon btn btn-size-32"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-book-image",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d14eb2ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Dashboard.vue
// module id = 189
// module chunks = 1